import { useContext } from "react";
import { CurrentUserContext } from "../auth/AuthProvider";
import type { UserResponse } from "../types/user";

export function useCurrentUser(): UserResponse {
  const user = useContext(CurrentUserContext);
  if (!user) throw new Error("useCurrentUser must be used inside AuthProvider");
  return user;
}
